import { render } from "./HBEHotelRoomTypePriceDownload.vue?vue&type=template&id=61f861b2&scoped=true"
import script from "./HBEHotelRoomTypePriceDownload.vue?vue&type=script&lang=js"
export * from "./HBEHotelRoomTypePriceDownload.vue?vue&type=script&lang=js"

import "./HBEHotelRoomTypePriceDownload.vue?vue&type=style&index=0&id=61f861b2&scoped=true&lang=css"

import exportComponent from "/cwt/data/jenkins/workspace/RoomIt-HotelWeb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61f861b2"]])

export default __exports__